enum RequestStatus {
  NOT_STARTED = 'notStarted',
  LOADING = 'loading',
  LOADED = 'loaded',
  ERRORED = 'errored',
};

export {
  RequestStatus,
};
